import { PetOwner } from '@app/core/models';
import { createAction, props } from '@ngrx/store';
import { NewPetStep } from '../../new-pet-step';
/**
 * Action dispatched to start a pet creation flow
 * It resets new pet store data
 */
export const startNewPet = createAction('[New Pet] Start', props<{ owner?: PetOwner }>());
/**
 * Set current step
 */
export const setNewPetStep = createAction('[New Pet] Set Step', props<{ value: NewPetStep }>());
/**
 * Set steps
 */
export const setNewPetSteps = createAction('[New Pet] Set Steps', props<{ value: NewPetStep[] }>());
/**
 * Reset daily allowance store
 */
export const resetNewPetState = createAction('[New Pet] Reset State');
